import {ClientServiceModel } from './client-service.model';

export class LoginUserModel {
    Email:string;
    Password: string;
    returnUrl: string;
    customerUrl?: string;
    defaultService?: string;
    isSuccess?: number;
    applications?:ClientServiceModel[];
    userId?: number;
    userName?: string;
    firstName?: string;
    token?: string;
    customerId?: number;
    Client1?: string;
    Client2?: string;
    isvalidRedirectApp?: boolean;
    authenticationTypeID?: number;
    LoginBGImage?:string;
    LoginLogo?:string;
    loginMarketingDesc?:string;
    constructor(){
        this.Email = '';
        this.Password = '';
        this.returnUrl = '';
        this.customerUrl = '';
        this.defaultService = '';
        this.applications = [];
        this.token = "";
        this.customerId = 0;
        this.userId = 0;
        this.Client1 = "";
        this.Client2 = "";
        this.isvalidRedirectApp = false;
        this.authenticationTypeID = 0;
        this.LoginBGImage = "";
        this.loginMarketingDesc="";
        this.LoginLogo="";
    }
}
